<template>
  <div>
    <div>
      <div class="row pt-3 l-m-b-20">
        <div class="col-8">
          <h1>Messages</h1>
        </div>
      </div>
    </div>
    <template v-if="!threads">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover">
        <thead class="m-table__heading">
          <tr>
            <th />
            <th class="m-table__id">Date</th>
            <th>Message</th>
            <th>Mover</th>
            <th>Carrier</th>
            <th>Job</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="thread in threads"
              :key="thread.id"
              @click="$_can('carriers.movers.show-text-message-thread') && getThread(thread.id)"
              class="pointer"
          >
            <td class="text-center">
              <div :class="thread.new && 'dot-blue'" />
            </td>
            <td>{{ thread.created_at }}</td>
            <td class="text-wrap">{{ thread.body }}</td>
            <td>{{ thread.mover_first_name }} {{ thread.mover_last_name }}</td>
            <td>{{ thread.carrier_name }}</td>
            <td><router-link :to="{ name: 'JobsEdit', params: { id: thread.job_id }}">{{ thread.ref_id }}</router-link></td>
            <td />
          </tr>
          <tr v-if="threads && !threads.length">
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row blocks">
        <div class="col-md-6 mb-1 text-black-50 d-none d-md-block"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-md-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <modal v-if="showModal" @close="closeModal" :size="'modal-large'">
      <div slot="header">
        <h4>Chat history</h4>
      </div>
      <div slot="body">
        <div class="container">
          <div class="row mb-4">
            <div class="col">
              <div class="select-wrap">
                <label>Send to</label>
                <p class="form-control">
                  {{ thread.meta.receiver.phone ? phoneMask.maskedPhone(thread.meta.receiver.phone) : 'No phone added' }}
                </p>
              </div>
            </div>
          </div>
          <div class="row mb-4 scrollable">
            <div class="col-12" v-for="message in thread.data" :key="message.id">
              <template v-if="message.direction === 2">
                <div class="row">
                  <div class="col-9 bg-primary rounded">
                    <p class="m-1 text-white">{{ message.body }}</p>
                    <p v-for="media in message.media" :key="media.id" class="w-25 text-media pointer" @click="openFile(media.url)">
                      <img :src="media.url" class="img img-fluid" alt="" />
                    </p>
                  </div>
                  <div class="col-3" />
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
              <template v-else class="m-1">
                <div class="row">
                  <div class="col-3" />
                  <div class="col-9 bg-light rounded">
                    <p class="m-1">{{ message.body }}</p>
                    <p v-for="media in message.media" :key="media.id" class="w-25 text-media pointer" @click="openFile(media.url)">
                      <img :src="media.url" class="img img-fluid" alt="" />
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col text-right">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-10 pr-0">
              <div class="select-wrap h-auto">
                <label>{{ thread.meta.sender.carrier_name }} {{ thread.meta.sender.phone }}:</label>
                <div contenteditable="true">
                  <textarea class="form-control"
                            v-model="sms"
                            @keypress.enter.prevent="send"
                            :disabled="sending"
                  />
                </div>
              </div>
            </div>
            <div class="col-2 pl-0">
              <button type="button"
                      class="pt-2 w-100 btn btn-primary ld-ext-right"
                      :class="sending ? 'running' : ''"
                      @click="send"
                      :disabled="!sms || sending"
              >
                <span class="mod-icon-note" />
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12" />
        </div>
        <div class="clearfix" />
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Pagination from '../Pagination';
import Modal from '../Modal';
import Errors from '../../classes/Errors';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'Messages',
  components: {
    Pagination,
    Modal,
  },
  data: () => ({
    q: '',
    page: 1,
    carrier: '',
    threads: null,
    thread: {
      data: {
        body: null,
      },
      meta: null,
    },
    threadId: null,
    sms: '',
    showModal: false,
    sending: false,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  mounted() {
    this.getAllThreads();
  },
  methods: {
    changePage(pageNum) {
      this.page = pageNum;
      this.getAllThreads();
    },
    getAllThreads() {
      axios
        .get(`movers/text-message-threads?page=${this.page}`)
        .then(res => {
          this.threads = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getThread(threadId) {
      if (threadId) {
        this.threadId = threadId;
      }
      axios
        .get(`movers/text-message-threads/${this.threadId}`)
        .then(res => {
          this.getAllThreads();
          this.thread = res.data;
          this.showModal = true;
          this.$nextTick(() => {
            const el = document.querySelector('.scrollable');
            el.scrollTop = el.scrollHeight;
          });
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    closeModal() {
      this.showModal = false;
      this.getAllThreads();
      this.sms = '';
    },
    send() {
      if (this.$_can('carriers.movers.show-text-message-thread')) {
        if (!this.sms.trim()) {
          return;
        }
        this.sending = true;
        axios
          .post(`movers/text-messages`, {
            carrier_id: this.thread.meta.sender.carrier_id,
            mover_ids: [this.thread.meta.receiver.user_id],
            body: this.sms,
          })
          .then(() => {
            toastr.success('Message sent successfully');
            this.sms = '';
            this.getThread();
          })
          .catch(err => this.errors.record(err.response.data.error))
          .finally(() => {
            this.sending = false;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/SettingsMoverMessages.vue